import { toast } from "react-toastify";
import { GetTenantDetails, postDataFromApi, putDataFromApi } from "../../../../../services/commonServices";
import { useNavigate } from "react-router-dom";
import { getSingleBranchSalesApi } from "../../../../../services/api";

export const getSingleBranchSales = async (EditRecordId, setFormData, status) => {

    let payload = { "bs_id": EditRecordId }
    let res = await postDataFromApi(getSingleBranchSalesApi, payload)

    if (res.data.status === 200) {
        const data = res?.data?.data;

        setFormData((prevFormData) => {
            const updatedData = {
                ...prevFormData,
                0: {
                    ...prevFormData[0],
                    month: data?.month || "",
                    year: data?.year || "",
                    invoice_amount: data?.invoice_amount || "",
                    gst_amount: data?.gst_amount || "",
                    total_amount: data?.total_amount || "",
                    client: data?.client?.cust_name || "",
                    company: status === "View"
                        ? data?.company?.cmp_name
                        : data?.company?.cmp_id,

                    branch: status === "View"
                        ? data?.branch?.br_name
                        : data?.branch?.br_id,
                    yearly_sales: data?.yearly_sales,
                    invoices_data: data?.invoices_data || [],
                    certificate_data: data?.certificate_data || [],
                    ref_no_data: data?.ref_no_data || [],

                    ...data?.expense_comment_json
                },
            };

            return updatedData;
        });

    } else {
        toast.error(res.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    }
}